/**
 * @legacy
 * @prev administration/templates/administration/reseller/ticket_create_update.html
 */

import loader from '../../../ui/legacy/img/alwaysdata-loader.gif'

import './spellingarea'

const flags = JSON.parse(document.body.dataset.flags)
const urls = JSON.parse(document.body.dataset.urls)

$(document).ready(function () {
  $('#check-language-btn').checkSpelling('id_message', 'check-language-info')

  if (flags.hasObject) {
    $('a.change_status').click(function () {
      $.ajax({
        url: urls.resellerTicketChangeStatus,
        data: { status: $('a.change_status').hasClass('has_not_read_staff') },
        success: function (data) {
          if ($('a.change_status').hasClass('has_not_read_staff')) {
            $('a.change_status')
              .removeClass('has_not_read_staff')
              .addClass('has_read_staff')
            $('a.change_status').text(gettext('Marquer comme non traité'))
            $('span.status').text(gettext('Traité'))
          } else {
            $('a.change_status')
              .removeClass('has_read_staff')
              .addClass('has_not_read_staff')
            $('a.change_status').text(gettext('Marquer comme traité'))
            $('span.status').text(gettext('Non traité'))
          }
        }
      })
    })

    $('a.change_assignment').click(function () {
      $('span.assigned_to').html(`<img src="${loader}" />`)
      $.getJSON(urls.resellerTicketChangeAssignment, function (data) {
        if (!data.success) {
          alert(gettext('Ticket déjà assigné.'))
        }
        $('#id_assigned_to').val(data.id).trigger('change')
        $('a.change_assignment').hide()
      })
    })
  }

  $('#id_template').change(function () {
    if ($(this).val()) {
      $.getJSON(urls.ticketTemplateOutput + $(this).val(), function (data) {
        $('#id_message').val(data['message'])
        if ($('#id_subject').length > 0 && data['subject']) {
          $('#id_subject').val(data['subject'])
        }
      })
    }
  })
})

document.addEventListener('keydown', (event) => {
  let messageForm = document.querySelector('#message-form')
  if (
    (event.ctrlKey || event.metaKey) &&
    (event.keyCode === 13 || event.keyCode === 10)
  ) {
    messageForm.submit()
  }
})

/**
 * @legacy
 * @prev administration/templates/administration/support_ticket_create_update.html
 */
$('form').submit(function () {
  $(this).find('button').attr('disabled', true)
  return true
})
